import React from "react";

function ItemCard() {
  // Submit button functionality
  return (
    <div className="card">
      <a>
        <img src="https://via.placeholder.com/150"></img>
      </a>
      <h3>Shoes/ITEM NAME</h3>
      <button>Button</button>
    </div>
  );
}

export default ItemCard;
